/**
 * @param {string} locale
 * @param {number} day Same as returned by Date#getDay(), so 1 is Monday
 * @returns {string} Locale string
 */
export const getLocalisedDay = (locale, day) => {
  const date = new Date(`2020-06-${Number(day)}`) // 2020-06-01 is Monday
  return date.toLocaleString(locale, { weekday: 'short' })
}

/**
 * @param {string} locale
 * @param {number} time Time in hours
 * @returns {string} Locale string
 */
export const getLocalisedHour = (locale, time) => {
  const date = new Date('2000-01-01')
  date.setHours(time)
  date.setMinutes((time - Math.floor(time)) * 60)
  return (
    date
      .toLocaleString(locale, { hour: 'numeric', minute: 'numeric' })
      // We don’t want leading 0, even if locale prefers it
      .replace(/^0/, '')
  )
}
